import styled from "styled-components";
import {SIZES} from "@/components/constants";
import ServiceBgPc from "@public/assets/main/service-bg-pc.png"

const EchoCycleSection = ({data}) => {
    return(
        <SectionWrap>
            <div className={"container"}>
                <div className={"text-box"}>
                    <h2 className={"item01"} dangerouslySetInnerHTML={{__html: data["main-pr1-title"]}}/>
                    <h2 className={"item02"} dangerouslySetInnerHTML={{__html: data["main-pr1-subtitle"]}}/>
                    <p className={"item03"} dangerouslySetInnerHTML={{__html: data["main-pr1-desc"]}}/>
                </div>
                <img src={data["main-pr1-img"]} alt={"서비스 이미지"}/>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 40px 0;
    .container {
        width: 100%;
        display: grid;
        margin: 0 auto;
        padding: 0 24px;
        gap: 20px;
        grid-template-columns: repeat(1, minmax(0, 1fr));
        .text-box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 16px;
            .item01, .item02{
                font-weight: 700;
                line-height: 28px;
                font-size: 18px;
            }
            .item03{
                line-height: 28px;
                font-size: 16px;
            }
        }
        .green {
            color: #07903a;
        }
    }

    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;
        }
    }
    
    @media (min-width: ${SIZES.TABLET}) {
        padding: 72px 0 32px;
        .container{
            padding: 0 40px;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            max-width: 1024px;
            .text-box{
                gap: 24px;
                .item01, .item02{
                    font-size: 40px;
                    line-height: 64px;
                }
                .item03{
                    font-size: 22px;
                    line-height: 40px;
                }
            }

            img{
                grid-column: span 2 / span 2;
            }
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;

        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`
export default EchoCycleSection;